export class GlobalSettings {
	public static readonly gutterHeight = 0;
	public static readonly panelPadding = 6;
	public static readonly panelSpace = 1;
}